<template>
    <div class="facDetail">
        <div class="back" @click="backBtn">&lt;&nbsp;{{$t('meg.back')}}</div>
        <div class="detailsBox">
            <div class="imgBox">
                <el-carousel indicator-position="outside" style="margin-top: 1.15rem;width: 25vw;">
                    <el-carousel-item v-for="citem in imageList" :key="citem">
                        <img :src="citem" alt="" style="width: 100%;height: 100%;" />
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div style="margin-left: .5375rem;">
                <h1
                    style="font-size: .275rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: bold;color: #000000;text-align: left;">
                    {{ plantData.plantAlias }}</h1>
                <div class="mainBox">
                    <el-button round class="btn" v-for="item in orderType" :key="item">{{ item }}</el-button>
                </div>
                <p
                    style="font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;margin-top: .4875rem;text-align: left;">
                    {{ plantData.plantIntroduce }}</p>
            </div>
        </div>
        <!-- <div class="infor">营业执照</div> -->
    </div>
</template>

<script setup>
import { facDetail } from "@/api/home.js"
import { onMounted, ref } from "vue";
import { useRouter, useRoute } from 'vue-router';

const plantId = ref("")
const route = useRoute();
const router = useRouter()
const plantData = ref({})
const orderType = ref([])
const imageList = ref([])
onMounted(() => {
    plantId.value = route.query.plantId
    getDetails()
})

const getDetails = () => {
    facDetail({ plantId: plantId.value }).then(res => {
        if (res.data.code == 200) {
            plantData.value = res.data.data
            plantData.value.pictures.forEach(item => {
                imageList.value.push(item.url)
            })
            orderType.value = plantData.value.orderType.split(",")
        }
    })
}
const backBtn = () => {
    router.go(-1)
}
</script>

<style scoped>
.back {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    text-align: left;
    margin-left: .425rem;
    margin-top: 1.625rem;
    padding-left: 4.125rem;
    cursor: pointer;
}

.detailsBox {
    margin: .25rem 4.5rem;
    /* background: pink; */
    display: flex;
}

.imgBox {
    width: 5.9625rem;
    /* height: 348px; */
}

.mainBox {
    margin-top: 1.875rem;
    text-align: left;
}

.mainBox .btn {
    height: .4125rem;
    border-radius: .75rem .75rem .75rem .75rem;
    opacity: 1;
    border: .0125rem solid #D8D8D8;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 300;
    color: #000000;
}

.infor {
    height: .6375rem;
    background: #EEEEEE;
    opacity: 1;
    margin: .2625rem 4.5rem;
    line-height: .6375rem;
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 700;
    color: #000000;
    text-align: left;
    padding-left: .25rem;
}</style>
